module.exports = __webpack_public_path__ + "static/gate5-c497f3dd120ec4c50f64e9faed60d999.jpg";